class BaseModel {

    init(jsonObj, handlers) {
        if(typeof(handlers) == 'undefined') {
            handlers = null;
        }
        handlers = handlers ?? this.initHandlers() ?? {};

        for (const key in jsonObj) {
            if(jsonObj.hasOwnProperty(key) && this.hasOwnProperty(key)) {
                if(handlers.hasOwnProperty(key)) {
                    jsonObj[key] = handlers[key].call(this, jsonObj[key], jsonObj);
                }
                this[key] = jsonObj[key];
            }
        }
    }

    initHandlers() {
        return {};
    }

    static isArray(a) {
        return Array.isArray(a);
    }

    static isHash(h) {
        return typeof(h) === 'object' && h !== null
    }

    merge(newObj) {
        if(newObj instanceof BaseModel) {
            var keys = Object.keys(newObj);
            for(let i = 0;i < keys.length;i++) {
                let key = keys[i];
                if(this.hasOwnProperty(key)) {
                    if(typeof(this[key]) != 'undefined' && typeof(newObj[key]) == 'undefined') {
                        continue;
                    } else if(this[key] instanceof BaseModel) {
                        this[key].merge(newObj[key]);
                    } else if(this[key] != newObj[key]) {
                        this[key] = newObj[key];
                    }
                }
            }
        } else {
            this.init(newObj, this.initHandlers());
        }
    }

    static AllCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    static AllLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    static AllNumbers = '1234567890';
    static generateId(length, characters) {
        if(typeof(length) == 'undefined') {
            length = 10;
        }
        if(typeof(characters) == 'undefined') {
            characters = BaseModel.AllCharacters;
        }

        let result = '';
        let charactersLength = characters.length;
        while (length > 0) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            length--;
        }
        return result;
    }
}

export { BaseModel }